/**
 * @generated SignedSource<<e62ff24866f004048987e01d70e523da>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LessonKind = "ARTICLE" | "AUDIO_ARTICLE" | "COMMENTARY" | "MINI_STORY" | "POV" | "VOCABULARY" | "%future added value";
export type LessonLibraryQuery$variables = {
  localDay: any;
  weekStart: any;
};
export type LessonLibraryQuery$data = {
  readonly me: {
    readonly learner: {
      readonly activeLessonSet: {
        readonly id: string;
      } | null | undefined;
      readonly defaultCharacter: {
        readonly audience: string;
      } | null | undefined;
      readonly id: string;
      readonly lessonDays: ReadonlyArray<{
        readonly completed: number;
        readonly localDay: any;
        readonly plays: number;
      }>;
      readonly lessonSets: ReadonlyArray<{
        readonly day: number | null | undefined;
        readonly daysPlayed: number;
        readonly id: string;
        readonly lessons: ReadonlyArray<{
          readonly id: string;
          readonly kind: LessonKind;
        }>;
        readonly level: number | null | undefined;
        readonly name: string;
        readonly startedAt: any | null | undefined;
      }>;
    } | null | undefined;
  } | null | undefined;
};
export type LessonLibraryQuery = {
  response: LessonLibraryQuery$data;
  variables: LessonLibraryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "localDay"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "weekStart"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "from",
      "variableName": "weekStart"
    },
    {
      "kind": "Variable",
      "name": "to",
      "variableName": "localDay"
    }
  ],
  "concreteType": "LessonDay",
  "kind": "LinkedField",
  "name": "lessonDays",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completed",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audience",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "LessonSet",
  "kind": "LinkedField",
  "name": "activeLessonSet",
  "plural": false,
  "selections": [
    (v1/*:: as any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "LessonSet",
  "kind": "LinkedField",
  "name": "lessonSets",
  "plural": true,
  "selections": [
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "level",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "localDay",
          "variableName": "localDay"
        }
      ],
      "kind": "ScalarField",
      "name": "day",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "daysPlayed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Lesson",
      "kind": "LinkedField",
      "name": "lessons",
      "plural": true,
      "selections": [
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "kind",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LessonLibraryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              },
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LessonLibraryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v1/*:: as any*/)
                ],
                "storageKey": null
              },
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2570337f41ac6e59f179b45253bfe7a7",
    "id": null,
    "metadata": {},
    "name": "LessonLibraryQuery",
    "operationKind": "query",
    "text": "query LessonLibraryQuery(\n  $localDay: NaiveDate!\n  $weekStart: NaiveDate!\n) {\n  me {\n    learner {\n      id\n      lessonDays(from: $weekStart, to: $localDay) {\n        localDay\n        plays\n        completed\n      }\n      defaultCharacter {\n        audience\n        id\n      }\n      activeLessonSet {\n        id\n      }\n      lessonSets {\n        id\n        name\n        level\n        startedAt\n        day(localDay: $localDay)\n        daysPlayed\n        lessons {\n          id\n          kind\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "347d2dfc8a5464669a3032c322c257c6";

export default node;
